import React, { Component } from 'react';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';


const MnNavBar = ({data,years,onReportClick}) => {


    // const getNavDropDowns = () =>{

    //     try{

    //         return(
    //             <>
    //                 <NavDropdown title="Data Enhancement" id="basic-nav-dropdown">
    //                     <NavDropdown.Item href="/serviceproviders">Service Providers</NavDropdown.Item>
    //                     <NavDropdown.Item href="/groupsiomessages">Groups IO Messages:  Unreviewed</NavDropdown.Item>
    //                     <NavDropdown.Item href="/groupsiomessages2">Groups IO Messages:  Review 2</NavDropdown.Item>
    //                     <NavDropdown.Item href="/categories">Categories</NavDropdown.Item>
    //                     <NavDropdown.Item href="/groupsiotopics">Groups IO Topics:  Unreviewed</NavDropdown.Item>
    //                 </NavDropdown>
    //             </>
    //         )
    //     }
    //     catch(ex){
    //         console.log(ex)
    //     }
    // }

    return(

        <Navbar bg="dark" variant="dark" style={{ backgroundColor:'#4682B4'}}>

            <Navbar.Brand>CSCA By Laws</Navbar.Brand>
            <Navbar.Brand>CSCA Minutes</Navbar.Brand>
            <Nav className="me-auto">
                {years.map((x,idx)=>(
                    <NavDropdown title={x} id="basic-nav-dropdown">
                        {data.filter(y=>y["year"]==x).map((z,idx2)=>(
                            <NavDropdown.Item onClick={(e=>onReportClick(e,z))}>{z["meetingName"]}</NavDropdown.Item>
                        ))}
                    </NavDropdown>
                ))}
            </Nav>
        </Navbar>
    )
    
}
 
export default MnNavBar;
